import { Check, Lock } from "lucide-react";
import { REVENUE_RANGES, BANK_OPTIONS, PARTICULARITIES, SHARE_RANGES, OVERDRAFT_RANGES, DEFAULT_RANGE } from "../../lib/savingsFormula";
import { OptionButton, CheckOption, QuestionTitle } from "./SimUI";

export const StepRevenue = ({ value, onSelect }) => (
    <div className="flex flex-col gap-5">
        <QuestionTitle>Quel est le chiffre d'affaires annuel de votre entreprise&nbsp;?</QuestionTitle>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {REVENUE_RANGES.map((r, i) => (
                <OptionButton key={r.key} selected={value === r.key} onClick={() => onSelect(r.key)} testid={`sim-revenue-${r.key}`} delay={i * 60} className="min-h-[64px]">
                    {r.label}
                </OptionButton>
            ))}
        </div>
        <div className="border-t border-border-soft pt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-grey-text">
            <span className="inline-flex items-center gap-1.5"><Check size={15} className="text-gold-text" />Gratuit</span>
            <span className="inline-flex items-center gap-1.5"><Lock size={15} className="text-gold-text" />Anonyme</span>
            <span className="inline-flex items-center gap-1.5"><Check size={15} className="text-gold-text" />Sans engagement</span>
        </div>
    </div>
);

export const StepBanks = ({ value, onSelect }) => (
    <div className="flex flex-col gap-5">
        <QuestionTitle>Avec combien de banques travaillez-vous&nbsp;?</QuestionTitle>
        <div className="flex flex-col gap-3">
            {BANK_OPTIONS.map((b, i) => (
                <OptionButton key={b.n} selected={value === b.n} onClick={() => onSelect(b.n)} testid={`sim-banks-${b.n}`} delay={i * 60}>
                    {b.label}
                </OptionButton>
            ))}
        </div>
    </div>
);

const SubRanges = ({ label, ranges, value, onChange, pKey }) => (
    <div role="group" aria-label={label} className="pl-4 md:pl-8 pt-2 pb-1 flex flex-col gap-2 animate-fade-up">
        <span className="text-[13px] text-grey-text-soft">{label}</span>
        <div className="grid grid-cols-3 gap-2">
            {ranges.map((r) => (
                <button
                    key={r.key}
                    type="button"
                    aria-pressed={value === r.key}
                    onClick={() => onChange(r.key)}
                    data-testid={`sim-range-${pKey}-${r.key}`}
                    className={`min-h-[44px] px-2 rounded-lg border-[1.5px] text-[13px] md:text-sm font-semibold text-navy transition-colors ${
                        value === r.key ? "border-gold-dark bg-sand" : "border-border-default bg-white hover:border-navy"
                    }`}
                >
                    {r.label}
                </button>
            ))}
        </div>
    </div>
);

export const StepParticularities = ({ selected, none, onChange, onSubmit }) => {
    const toggle = (p) => {
        const next = { ...selected };
        if (next[p.key]) delete next[p.key];
        else next[p.key] = p.kind === "info" ? true : DEFAULT_RANGE[p.kind];
        onChange(next, false);
    };
    const nothingChosen = !none && Object.keys(selected).length === 0;
    return (
        <div className="flex flex-col gap-3">
            <QuestionTitle>Votre activité comporte-t-elle l'une de ces particularités&nbsp;?</QuestionTitle>
            <p className="m-0 mb-2 text-sm text-grey-text-soft">Plusieurs réponses possibles. Indiquez ensuite la part concernée d'un simple clic.</p>
            {PARTICULARITIES.map((p) => (
                <div key={p.key}>
                    <CheckOption checked={Boolean(selected[p.key])} onClick={() => toggle(p)} testid={`sim-part-${p.key}`}>{p.label}</CheckOption>
                    {selected[p.key] && p.kind !== "info" && (
                        <SubRanges
                            pKey={p.key}
                            label={p.kind === "share" ? "Part du CA concernée" : "Montant moyen utilisé"}
                            ranges={p.kind === "share" ? SHARE_RANGES : OVERDRAFT_RANGES}
                            value={selected[p.key]}
                            onChange={(r) => onChange({ ...selected, [p.key]: r }, false)}
                        />
                    )}
                </div>
            ))}
            <CheckOption checked={none} onClick={() => onChange({}, !none)} testid="sim-part-none">Aucune de ces particularités</CheckOption>
            <button
                type="button"
                onClick={onSubmit}
                data-testid="sim-submit"
                className="mt-2 h-[54px] rounded-[10px] bg-gold text-navy text-base font-semibold transition-[transform,box-shadow] hover:-translate-y-[1px] hover:shadow-lg"
            >
                {nothingChosen ? "Passer et voir mon estimation" : "Voir mon estimation"}
            </button>
        </div>
    );
};
